import styled, { css } from "styled-components";

import { COLOR_VALUES } from "shared/config/colors";

export const Wrapper = styled.div`
    border-bottom: 1px solid ${COLOR_VALUES.Gray_6};
`;

export const TabsUL = styled.ul`
    display: flex;
    margin: 0 0 -1px;
    padding: 0;
`;

export const TabsLI = styled.li`
    list-style: none;
`;

export const TabWrapper = styled.div`
    cursor: pointer;
    display: inline-flex;
    text-decoration: none;
    padding: 16px;
    gap: 4px;
    align-items: center;
    background: ${COLOR_VALUES.White};
    color: ${COLOR_VALUES.Gray_4} !important; /* !important to override css reboot */
    text-decoration: none !important; /* !important to override css reboot */

    &:hover {
        background: ${COLOR_VALUES.Gray_8};
        border-bottom: 2px solid ${COLOR_VALUES.Gray_6};
    }

    ${(props) =>
        props.isActive &&
        css`
            color: ${COLOR_VALUES.Black} !important; /* !important to override css reboot */
            border-bottom: 2px solid ${COLOR_VALUES.Black};
        `}
`;
